import { connect } from 'react-redux';
import { branch, compose, renderNothing, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { businessActions, businessSelector } from '../../../../state/modules/business';
import Content from './../../shared/publish-content/content';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  contentDetailsRoute: routes.app.library.contentDetails,
  contentResult: state.business.content.contentResult,
  nonCpdContent: state.business.content.nonCpdContent,
  isFetchingContent: state.business.content.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.business.content.isFetching ||
    state.business.content.isLoadingMore,
  allowDelete: false,
  choosePublisher: false,
  hideIndustries: true
});

const mapDispatchToProps = (dispatch) => ({
  businessLibraryLoadMoreContent: bindActionCreators(businessActions.business.content.loadMore, dispatch),
  businessLibraryGetContent: bindActionCreators(businessActions.business.content.get, dispatch),
  businessLibraryDeleteContent: bindActionCreators(businessActions.business.content.deleteContent, dispatch),
  businessLibraryGetNonCpdContent: bindActionCreators(businessActions.business.content.getNonCpdContent, dispatch),
  businessLibraryArchiveContent: bindActionCreators(businessActions.business.content.archiveContent, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderNothing
  ),
  withHandlers({
    loadMoreContent: ({ business, businessLibraryLoadMoreContent }) => (skip, query) => {
      businessLibraryLoadMoreContent(business.id, skip, query)
    },
    getContent: ({ business, businessLibraryGetContent }) => (skip, query) => {
      businessLibraryGetContent(business.id, skip, query)
    },
    deleteContent: ({ business, businessLibraryDeleteContent }) => (contentId, query) => {
      businessLibraryDeleteContent(business.id, contentId, query)
    },
    getNonCpdContent: ({ business, businessLibraryGetNonCpdContent }) => () => {
      businessLibraryGetNonCpdContent(business.id)
    },
    archiveContent: ({ business, businessLibraryArchiveContent }) => (content) => {
      businessLibraryArchiveContent(business.id, content)
    }
  })
)(Content);


// WEBPACK FOOTER //
// ./src/containers/pages/app/business-library/content.js